export * from './inflation-hedge-diversify'
